// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2538":"6a9239cae5943bdd","3855":"34472a947f984531","4130":"3894a2ed6da7c146","6320":"ba0a07eacf1202b3"}[chunkId] + ".js";
};